import Header from '@/components/elements/Header/Header';
import { bookingFlowTrackingSession } from '@/helpers/checkoutFlowTrackingSession';
import { useAppSelector } from '@/hooks';
import useMobileView from '@/hooks/useMobileView';
import { _s } from '@/locale';
import { BookState } from '@/types/state/book';
import { CampaignProduct } from '@/types/state/shared';
import { useMemo } from 'react';
import Modal from '../../redesign/Modal/Modal';
import { getPickedEmployee, ScrollToTopElement } from '../BookAppointment.helpers';
import { useBookAppointmentContext } from '../BookAppointment.hooks';
import ServiceCategoryList from '../shared/ServiceCategoryList';
import Summary from '../shared/Summary';

const baseTranslationKey = 'components.modules.modals.BookAppointment.views.PickServiceView';

const PickServiceView = () => {
  const { isMobileView } = useMobileView();
  const context = useBookAppointmentContext();
  const { employee, place, services: pickedServices, campaigns } = useAppSelector((state) => state.book) as BookState;
  const pickedEmployee = getPickedEmployee(employee, place.employees);

  const pickedProducts = useMemo(() => {
    if (!campaigns) return [];
    const products: CampaignProduct[] = [];

    campaigns.forEach((campaign) => {
      if (campaign.type === 7 && campaign.publicationType === 2 && campaign.products?.length > 0) {
        products.push(...campaign.products);
      }
    });
    return products;
  }, [campaigns]);

  const handleOnBack = () => {
    context.close();
    bookingFlowTrackingSession.cancelSession();
  };

  return (
    <Modal.Content floating={!isMobileView}>
      <ScrollToTopElement />
      <Modal.Header title={_s(`${baseTranslationKey}.title`)} onBack={handleOnBack} />
      <div className={`pb-lg flex flex-col ${isMobileView ? 'px-lg' : ''}`}>
        <div className="p-md">
          <Summary
            pickedEmployee={pickedEmployee}
            pickedServices={pickedServices}
            pickedProducts={pickedProducts}
            showPickedEmployee
            showAddAdditionalService={false}
          />
        </div>
        <div className="pt-xxl">
          <Header label={_s(`${baseTranslationKey}.title`)} size="md" />
        </div>
        <ul>
          <ServiceCategoryList />
        </ul>
      </div>
    </Modal.Content>
  );
};

export default PickServiceView;
